export default __webpack_public_path__ + "static/media/simple_active.96effd0e.svg";